module.exports = __webpack_public_path__ + "img/caneca_azul.809c06fb.png";